import moment from "moment";
import es from "./es";
moment.updateLocale("es", es);

export default moment;
